import Vue from 'vue';
import Vuex from 'vuex';
import TestSession from '@/models/TestSession';
import api from '@/api';

import user from './user';
import userGroups from './userGroups';
import breadcrumbs from './breadcrumbs';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user, // Авторизованный пользователь
    userGroups, // Все группы пользователей
    breadcrumbs, // Хлебные крошки
  },

  state: {
    // Текущая сессия прохождения тестирования
    testSession: null,
    testSessionLoaded: false,

    // Таймер прохождения теста (обратный отсчет)
    testCountdown: 0,
  },

  getters: {
    getTestCountdown({ testCountdown }) {
      return testCountdown;
    },

    getTestSession({ testSession }) {
      return testSession ? new TestSession(testSession) : null;
    },

    getTestingTime({ testCountdown }) {
      if (testCountdown > 0) {
        let m = Math.floor(testCountdown / 60);
        let s = Math.floor(testCountdown - m * 60);
        if (m < 10) m = '0' + m;
        if (s < 10) s = '0' + s;
        return `${m}:${s}`;
      }
      return '';
    },
  },

  mutations: {
    setTestSession(state, payload = null) {
      state.testSessionLoaded = true;
      state.testSession = payload;
      if (payload && payload.time > 0) {
        state.testCountdown = payload.complete ? 0 : payload.time;
      }
    },

    countdown(state) {
      if (state.testCountdown > 0) {
        state.testCountdown--;
      }
    },

    stopCountdown(state) {
      state.testCountdown = 0;
    },
  },

  actions: {
    async loadTestSession({ commit }) {
      const response = await api.for('sessions/active').fetch();

      commit('setTestSession', new TestSession(response.data));
    },
  },
});
